import { Area, AreaChart, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import type { CurvePoint } from './talentMapShared';

// Los puntos (`buildCurvePoints`, `curvePointMeta`) viven en talentMapShared:
// este archivo exporta solo el componente, para que Fast Refresh funcione.
export type { CurvePoint };

/**
 * Curva de distribución de categorías (doc People "Aclaración visual 02/09"):
 * eje X en el orden Sin completar → Onboarding → Low → Cumple c/oportunidades
 * → Sólida → Top; eje Y = cantidad; cada punto muestra su cantidad y mantiene
 * el color de la categoría. Reutilizada por el panel del Mapa del equipo y por
 * la tab Analytics people.
 */

interface Props {
  points: CurvePoint[];
  height?: number;
  /** Mostrar labels del eje X (vista ancha — Analytics people). */
  showAxis?: boolean;
}

export function CategoryCurve({ points, height = 190, showAxis = false }: Props) {
  const maxCount = Math.max(1, ...points.map(p => p.count));
  const renderDot = (props: any) => {
    const p = points[props.index];
    return (
      <circle
        key={p?.key ?? props.index}
        cx={props.cx}
        cy={props.cy}
        r={4.5}
        fill={p?.color ?? '#999'}
        stroke="var(--curve-dot-stroke, #fff)"
        strokeWidth={1.5}
      />
    );
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={points} margin={{ top: 20, right: 14, left: 14, bottom: showAxis ? 4 : 0 }}>
        <defs>
          <linearGradient id="tmCurveFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#14B8A6" stopOpacity={0.22} />
            <stop offset="100%" stopColor="#14B8A6" stopOpacity={0.02} />
          </linearGradient>
        </defs>
        {showAxis && (
          <XAxis
            dataKey="shortLabel"
            fontSize={10}
            tickLine={false}
            axisLine={false}
            interval={0}
          />
        )}
        <YAxis hide domain={[0, Math.ceil(maxCount * 1.3) + 1]} allowDecimals={false} />
        <Area
          type="monotone"
          dataKey="count"
          stroke="#14B8A6"
          strokeWidth={2}
          fill="url(#tmCurveFill)"
          isAnimationActive={false}
          dot={renderDot as any}
          activeDot={false}
        >
          <LabelList
            dataKey="count"
            position="top"
            offset={9}
            className="fill-foreground"
            fontSize={11}
            fontWeight={600}
          />
        </Area>
      </AreaChart>
    </ResponsiveContainer>
  );
}
